import React from "react";
import {
  ButtonBase,
  makeStyles,
  Modal,
  useTheme,
  Box,
  useMediaQuery,
  DialogActions,
  Slide,
  IconButton,
  DialogContent,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Grid } from "ui/grid/Grid";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const FunnelModal = ({
  children,
  trigger = undefined,
  tooltip = false,
  title = undefined,
  open: openModal = false,
  cancel = undefined,
  confirm = undefined,
  size,
  topIcon = undefined,
  showDividers,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const contentRef = React.useRef(null);
  const [padding, setPadding] = React.useState({});
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(openModal || false);
  const handleClick = React.useCallback(() => {
    setOpen((prevState) => !prevState);
  }, []);
  const hasActions = React.useMemo(() => cancel || confirm, [cancel, confirm]);

  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  React.useEffect(() => {
    if (contentRef.current) {
      if (contentRef.current.offsetHeight - contentRef.current.offsetTop >= window.innerHeight) {
        setPadding({
          paddingTop: 78,
        });
      }
    }
  }, [open, contentRef]);
  return (
    <>
      {tooltip && trigger && (
        <ButtonBase className={classes.button} onClick={handleClick}>
          {trigger}
        </ButtonBase>
      )}
      {!tooltip && trigger && React.cloneElement(trigger, { onClick: handleClick })}
      {isTablet && (
        <Modal open={open} onClose={handleClick} keepMounted>
          <Slide direction="up" in={open} mountOnEnter unmountOnExit>
            <div className={classes.mobileContainer} ref={contentRef}>
              <Grid container className={classes.mobileHeader} justify="center">
                <Grid item xs={12}>
                  <IconButton className={classes.buttonClose} size="small" onClick={handleClick}>
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={12}>
                  {title && <Box p={1}>{title}</Box>}
                </Grid>
              </Grid>
              <div style={{ ...padding, paddingBottom: hasActions ? 68 : 0 }} className={classes.mobileContent}>
                {children}
              </div>
              {hasActions && (
                <div className={classes.mobileFooter}>
                  <DialogActions>
                    {cancel}
                    {confirm}
                  </DialogActions>
                </div>
              )}
            </div>
          </Slide>
        </Modal>
      )}
      {!isTablet && (
        <Dialog
          scroll="paper"
          open={open}
          TransitionComponent={Transition}
          keepMounted
          PaperProps={{
            style: { width: "100%", padding: 24 },
          }}
          onClose={handleClick}
          maxWidth={size}
        >
          {topIcon && (
            <Grid container spacing={2}>
              <Grid item style={{ textAlign: "center", width: "100%", paddingTop: 40 }}>
                {topIcon}
              </Grid>
            </Grid>
          )}
          <DialogTitle disableTypography className={classes.root}>
            {title}
            {handleClick ? (
              <IconButton onClick={handleClick} size="small" className={classes.closeButton}>
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>
          <DialogContent dividers={Boolean(title) && showDividers} className={classes.content}>
            {children}
          </DialogContent>
          {hasActions && (
            <DialogActions>
              {cancel}
              {confirm}
            </DialogActions>
          )}
        </Dialog>
      )}
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  modal: {
    width: 500,
  },
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  buttonClose: {
    width: "100%",
    padding: theme.spacing(),
  },
  button: {
    padding: theme.spacing(1),
    borderRadius: "50%",
  },
  content: {
    padding: 0,
  },
  mobileContainer: {
    width: "100%",
    maxHeight: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    outline: 0,
    position: "absolute",
    backgroundColor: "white",
    bottom: 0,
  },
  mobileHeader: {
    padding: theme.spacing(0.5),
    paddingBottom: theme.spacing(2),
    position: "sticky",
    width: "100%",
    top: 0,
    backgroundColor: theme.palette.common.white,
    textAlign: "center",
  },
  mobileFooter: {
    position: "absolute",
    bottom: 0,
    left: 0,
    zIndex: 2,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.common.white,
    borderTop: "solid 1px rgba(0, 0, 0, 0.12)",
  },
  mobileContent: {
    zIndex: 1,
    maxHeight: "100vh",
    overflowY: "scroll",
    width: "100%",
  },
}));
